
import LayoutMixin from '@/mixins/layout'
import Banner from './components/banner.vue'
import Nav from './components/nav.vue'

export default {
  components: {
    Nav,
    Banner,
  },
  mixins: [LayoutMixin],
  head() {
    return {
      title: this.$t(`modules.about.intro`) + this.$t('navs.suffixName'),
    }
  },
}
